import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AddResourceViewModel } from '../models/addResourceViewModel';
import { CommandResult } from '../models/commandResult';
import { OrderClientViewModel } from '../models/orderClientViewModel';
import { TransferViewModel } from '../models/transferViewModel';
import { ValueViewModel } from '../models/valueViewModel';
import { WithdrawTransfer } from '../models/withdrawTransfer';
import { Security } from '../utils/security.util';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor(private http: HttpClient) { }

  getById(id: string){
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/order/get/' + id, this.options());
  }

  getOrderDetails(id: string){
    return this.http.get<CommandResult>(environment.serviceUrl + 'v1/order/details/' + id, this.options());
  }

  resourceDeposit(data: AddResourceViewModel) {
    return this.http.post<CommandResult>(environment.serviceUrl + 'v1/client/order/resourcedeposit', data, this.options());
  }

  transferBetweenUsers(data: TransferViewModel) {
    return this.http.post<CommandResult>(environment.serviceUrl + 'v1/client/order/transferBetweenUsers', data, this.options());
  }

  exchangeRealByBs(data: ValueViewModel) {
    return this.http.post<CommandResult>(environment.serviceUrl + 'v1/client/order/exchangeRealByBs', data, this.options());
  }

  exchangeBsByReal(data: ValueViewModel) {
    return this.http.post<CommandResult>(environment.serviceUrl + 'v1/client/order/exchangeBsByReal', data, this.options());
  }

  exchangeDolarByBs(data: ValueViewModel) {
    return this.http.post<CommandResult>(environment.serviceUrl + 'v1/client/order/exchangeDolarByBs', data, this.options());
  }

  exchangeBsByDolar(data: ValueViewModel) {
    return this.http.post<CommandResult>(environment.serviceUrl + 'v1/client/order/exchangeBsByDolar', data, this.options());
  }

  exchangeRealByDolar(data: ValueViewModel) {
    return this.http.post<CommandResult>(environment.serviceUrl + 'v1/client/order/exchangeRealByDolar', data, this.options());
  }

  exchangeDolaByReal(data: ValueViewModel) {
    return this.http.post<CommandResult>(environment.serviceUrl + 'v1/client/order/exchangeDolaByReal', data, this.options());
  }

  withdrawalByTransfer(data: WithdrawTransfer) {
    return this.http.post<CommandResult>(environment.serviceUrl + 'v1/client/order/withdrawalByTransfer', data, this.options());
  }

  withdrawalByPartner(data: ValueViewModel) {
    return this.http.post<CommandResult>(environment.serviceUrl + 'v1/client/order/withdrawalByPartner', data, this.options());
  }

  investment(data: OrderClientViewModel) {
    return this.http.post<CommandResult>(environment.serviceUrl + 'v1/client/order/investment', data, this.options());
  }

  returnInvestment() {
    return this.http.post<CommandResult>(environment.serviceUrl + 'v1/client/order/returnInvestment', this.options());
  }

  sendInterestToBalanceSm() {
    return this.http.post<CommandResult>(environment.serviceUrl + 'v1/client/order/sendInterestToBalanceSm', this.options());
  }


  options() {
    const headers = new HttpHeaders()
    .set('Authorization', `Bearer ${Security.getToken()}`)
    .set('api-version', Security.versionApi());
  return { headers };
  }
}
